import PropTypes from "prop-types";
import { styled } from "@mui/system";

const MyComponent = styled("div")({
  whiteSpace: "pre-wrap",
  fontWeight: "bolder",
});

const DateTimeCell = ({ value }) => {
  return <MyComponent>{value}</MyComponent>;
};

DateTimeCell.propTypes = {
  value: PropTypes.string,
};

export default DateTimeCell;
